// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + ({"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred","500":"page-unavailableProduct"}[chunkId] || chunkId) + "." + {"189":"5cf905f1a8e7881ec68b","404":"1f769afc0433559c927c","406":"6ea7911b4dbe79f69cec","500":"e144e6e03c04bb406163","808":"51fc290f71dedcf50fc4"}[chunkId] + ".css";
};